import React from 'react';
import {
  Link,
  Card,
  CardHeader,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { formatDateISOWithSeconds } from 'src/utils/date';
import { formatCurrency } from 'src/utils/currency';

const useStyles = makeStyles((theme) => ({
  card: {
    marginBottom: theme.spacing(2),
  },
  fontWeightMedium: {
    fontWeight: theme.typography.fontWeightMedium,
  },
  cardHeader: {
    color: theme.palette.secondary.main,
  },
}));

function OriginalPaymentInfo({
  poNumber,
  dispatchId,
  dateCreated,
  subtotal,
  tax,
  amountTotal,
  currencyType,
  firstName,
  lastName,
  invoiceId,
  callerEmail,
}) {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardHeader
        className={classes.cardHeader}
        title="Original Payment Info"
      />
      <Divider />
      <Table>
        <TableBody>
          <TableRow>
            <TableCell className={classes.fontWeightMedium}>PO Number</TableCell>
            <TableCell align="right">
              <Typography variant="body2" color="textSecondary">
                {poNumber ?? '-'}
              </Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.fontWeightMedium}>Dispatch ID</TableCell>
            <TableCell align="right">
              <Typography variant="body2" color="textSecondary">
                {dispatchId?? '-'}
              </Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.fontWeightMedium}>Subtotal</TableCell>
            <TableCell align="right">
              <Typography variant="body2" color="textSecondary">
                {formatCurrency(subtotal)?? '$0.00'}
              </Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.fontWeightMedium}>Tax</TableCell>
            <TableCell align="right">
              <Typography variant="body2" color="textSecondary">
                {formatCurrency(tax)?? '$0.00'}
              </Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.fontWeightMedium}>Total</TableCell>
            <TableCell align="right">
              <Typography variant="body2" color="textSecondary">
                {formatCurrency(amountTotal)}
              </Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.fontWeightMedium}>Currency Type</TableCell>
            <TableCell align="right">
              <Typography variant="body2" color="textSecondary">
                {currencyType.toUpperCase()}
              </Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.fontWeightMedium}>Date Submitted</TableCell>
            <TableCell align="right">
              <Typography variant="body2" color="textSecondary" component="div">
                {formatDateISOWithSeconds(dateCreated)}
              </Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.fontWeightMedium}>Caller Name</TableCell>
            <TableCell align="right">
              <Typography variant="body2" color="textSecondary" component="div">
                {`${firstName} ${lastName}`}
              </Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.fontWeightMedium}>Caller Email</TableCell>
            <TableCell align="right">
              <Typography variant="body2" color="textSecondary" component="div">
                {callerEmail}
              </Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.fontWeightMedium}>Link to Invoice In Stripe</TableCell>
            <TableCell align="right">
              <Typography variant="body2" color="textSecondary" component="div">
                 <Link
                  target='_blank'
                  href={`https://dashboard.stripe.com/invoices/${invoiceId}`}
                  rel="noreferrer"
                >
                  Open
                </Link>
              </Typography>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Card>
  );
}

OriginalPaymentInfo.propTypes = {
  poNumber: PropTypes.string,
  dispatchId: PropTypes.string,
  dateCreated: PropTypes.string,
  invoiceId: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  currencyType: PropTypes.string,
  callerEmail: PropTypes.string,
  subtotal: PropTypes.number,
  amountTotal: PropTypes.number,
  tax: PropTypes.number,
};

OriginalPaymentInfo.defaultProps = {
  poNumber: '',
  dispatchId: '',
  dateCreated: '',
  invoiceId: '',
  firstName: '',
  lastName: '',
  currencyType: 'usd',
  callerEmail: '',
  subtotal: '',
  amountTotal: '',
  tax: '',
};

export default OriginalPaymentInfo;
